// Liten hjälpare för att läsa GPS-koordinater + Plus-Code från en bilds EXIF-data.
//
// `exifr` läser GPS från JPEG/HEIC/TIFF/RAW.
// `open-location-code` är Googles officiella Plus-Code-bibliotek.

import exifr from "exifr";
import OpenLocationCode from "open-location-code";

const olc = new OpenLocationCode.OpenLocationCode();

/**
 * Läser ut GPS-data från en bildfil.
 * @param {File} file
 * @returns {Promise<{lat:number, lng:number, plusCode:string} | null>}
 */
export async function readGeoFromImage(file) {
  if (!file || !file.type || !file.type.startsWith("image/")) return null;
  try {
    const gps = await exifr.gps(file);
    if (!gps || typeof gps.latitude !== "number" || typeof gps.longitude !== "number") {
      return null;
    }
    if (gps.latitude < -90 || gps.latitude > 90) return null;
    if (gps.longitude < -180 || gps.longitude > 180) return null;
    const plusCode = olc.encode(gps.latitude, gps.longitude, 11);
    return { lat: gps.latitude, lng: gps.longitude, plusCode };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[exifGeo] kunde inte läsa GPS:", e?.message || e);
    return null;
  }
}

/**
 * Encode lat/lng → Plus-Code (full code, 11 tecken default).
 */
export function encodePlusCode(lat, lng, length = 11) {
  return olc.encode(lat, lng, length);
}
